import styled from "styled-components";

export const LoaderStyle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`